
import React from 'react';
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { Link } from "react-router-dom";

interface PricingHeaderProps {
  title: string;
  description?: string;
}

const PricingHeader = ({ title, description }: PricingHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div>
        <h1 className="text-3xl font-bold">{title}</h1>
        {description && (
          <p className="text-sm text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      <Link to="/">
        <Button variant="outline">
          <Home className="mr-2 h-4 w-4" />
          Go To Home
        </Button>
      </Link>
    </div>
  );
};

export default PricingHeader;
